export class Contentdeliverymail {
  id: number;
  deliverymailId: number;
  recipient: string;
  cc: string;
  subject: string;
  attachFiles: boolean;
  body: string;
  createAt: string;
  active: number;
}
